import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { CustomItemVerticalFourData } from './custom-item-vertical-four.model';
import { CmsComponentData } from '@spartacus/storefront';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-custom-item-vertical-four',
  templateUrl: './custom-item-vertical-four.component.html',
  styleUrls: ['./custom-item-vertical-four.component.scss'],
  standalone: false
})

export class CustomItemVerticalFourComponent implements OnInit {
  @Input() item: CustomItemVerticalFourData;
  @HostBinding('class') styleClasses: string;

  constructor(public component: CmsComponentData<CustomItemVerticalFourData>) { }

  data$ = this.component.data$.pipe(map(component => component));

  ngOnInit(): void {
  }

}
